module.exports = __webpack_public_path__ + "img/ic_cart.82b4dbae.svg";